import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, renderSlot as _renderSlot, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_datei_upload_liste = _resolveComponent("datei-upload-liste")!
  const _component_Infotext = _resolveComponent("Infotext")!
  const _component_abschluss_hinweise = _resolveComponent("abschluss-hinweise")!
  const _component_abschluss_ihre_daten = _resolveComponent("abschluss-ihre-daten")!
  const _component_abschluss_makler = _resolveComponent("abschluss-makler")!
  const _component_abschluss_direkt = _resolveComponent("abschluss-direkt")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_modal = _resolveComponent("modal")!
  const _component_buendel_dokument_links = _resolveComponent("buendel-dokument-links")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, {
        titel: (_ctx.piniaStore.state.isMakler === true ? '' : 'Ihr ') + 'Versicherungs­' + _ctx.getAntragOderVertrag(false),
        "ausrichtung-responsiv": false,
        "vertikal-zentrieren": false
      }, null, 8, ["titel"]),
      (_ctx.zeigeVersichertePerson)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 0,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[44] || (_cache[44] = _createTextVNode(" Versich­er­te Per­sonen  ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.geheZuBasisdaten && _ctx.geheZuBasisdaten(...args)))
                  }, "bearbeiten")
                ]),
                _: 1,
                __: [44]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "versichertePersonen" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getVersichertePersonen), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.piniaStore.state.tarifinformationen.tariff60Plus
            ? " (Versicherungsnehmer ab 60 Jahren werden in diesem Tarifrechner automatisch dem günstigen 60+ Tarif zugeordnet.)"
            : ""), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeVersichertesObjekt)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 1,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[45] || (_cache[45] = _createTextVNode(" Versichertes Objekt ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.geheZuBasisdaten && _ctx.geheZuBasisdaten(...args))),
                    onKeydown: [
                      _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuBasisdaten && _ctx.geheZuBasisdaten(...args)), ["enter"])),
                      _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuBasisdaten && _ctx.geheZuBasisdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Versichertes Objekt bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [45]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "versichertesObjekt" }), {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "versichertes-objekt")
                ]),
                _: 3
              }, 16)
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeObjektAnschrift)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 2,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[46] || (_cache[46] = _createTextVNode(" Objekt-Anschrift ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                    onKeydown: [
                      _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                      _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Objektanschrift bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [46]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "objektAnschrift" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.piniaStore.state.risikoAnschrift.plz) + " " + _toDisplayString(_ctx.piniaStore.state.risikoAnschrift.ort) + ", " + _toDisplayString(_ctx.piniaStore.state.risikoAnschrift.strasse) + " " + _toDisplayString(_ctx.piniaStore.state.risikoAnschrift.hausnummer), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeEigentumsverhaeltnisse)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 3,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[47] || (_cache[47] = _createTextVNode(" Eigentumsverhältnisse ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                    onKeydown: [
                      _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                      _cache[9] || (_cache[9] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Eigentumsverhältnisse bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [47]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "eigentumsverhaeltnisse" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.eigentumsverhaeltnisse), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.tarifinformationen.deckungssumme)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 4,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[48] || (_cache[48] = _createTextVNode(" Deckungssumme ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args))),
                    onKeydown: [
                      _cache[11] || (_cache[11] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["enter"])),
                      _cache[12] || (_cache[12] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Deckungssumme bearbeiten"
                  }, " bearbeiten ", 32)
                ]),
                _: 1,
                __: [48]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "deckungssumme" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getDeckungssumme), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeAnzahlVorschaeden)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 5,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[49] || (_cache[49] = _createTextVNode(" Anzahl Vorschäden ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                    onKeydown: [
                      _cache[14] || (_cache[14] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                      _cache[15] || (_cache[15] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Anzahl Vorschäden bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [49]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "anzahlVorschaeden" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.vorschaedenAnzahl), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeTarif)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 6,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true ? "" : "Ihr ") + "Tarif  ", 1),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args))),
                    onKeydown: [
                      _cache[17] || (_cache[17] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["enter"])),
                      _cache[18] || (_cache[18] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Tarif bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "tarifBezeichnung" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getTarifbezeichnung), 1),
                  _renderSlot(_ctx.$slots, "zusatzmodule")
                ]),
                _: 3
              }, 16)
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (_ctx.getSchadenfreiheitsrabatt)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 7,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[50] || (_cache[50] = _createTextVNode(" Schadenfreiheitsrabatt  ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args))),
                    onKeydown: [
                      _cache[20] || (_cache[20] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["enter"])),
                      _cache[21] || (_cache[21] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Schadenfreiheitsrabatt bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [50]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "schadenfreiheitsrabatt" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getSchadenfreiheitsrabatt), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "info-1"),
      (_ctx.zeigeSelbstbeteiligung)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 8,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[51] || (_cache[51] = _createTextVNode(" Selbst­be­teili­gung je Scha­den  ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args))),
                    onKeydown: [
                      _cache[23] || (_cache[23] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["enter"])),
                      _cache[24] || (_cache[24] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuVergleich && _ctx.geheZuVergleich(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Selbstbeteiligung bearbeiten"
                  }, "bearbeiten", 32)
                ]),
                _: 1,
                __: [51]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "selbstbeteiligung" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getSelbstbeteiligung), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.props.obligatorischeSelbstbeteiligung)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 9,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => _cache[52] || (_cache[52] = [
                  _createTextVNode(" Selbst­be­teili­gung je Scha­den")
                ])),
                _: 1,
                __: [52]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "obligatorische-selbstbeteiligung" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.props.obligatorischeSelbstbeteiligung) + " €", 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "zusaetzliche-selbstbeteiligung"),
      (_ctx.zusaetzlicheSbLw)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 10,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => _cache[53] || (_cache[53] = [
                  _createTextVNode(" Zu­sätz­liche Selbst­be­teili­gung je Leitungs­wasser-Scha­den  ")
                ])),
                _: 1,
                __: [53]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "zusaetzlicheSbLw" }), {
                default: _withCtx(() => _cache[54] || (_cache[54] = [
                  _createElementVNode("strong", null, "750 €", -1)
                ])),
                _: 1,
                __: [54]
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.zeigeDateien)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 11,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[55] || (_cache[55] = _createTextVNode(" Hochgeladene Dateien ")),
                  (!_ctx.piniaStore.state.preise.produktLinien[0].einmalig)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        role: "button",
                        tabindex: "0",
                        class: "u-copy-s field-edit",
                        onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                        onKeydown: [
                          _cache[26] || (_cache[26] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                          _cache[27] || (_cache[27] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                        ],
                        "aria-label": "Hochgeladene Dateien bearbeiten"
                      }, " bearbeiten ", 32))
                    : _createCommentVNode("", true)
                ]),
                _: 1,
                __: [55]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "dateien" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, [
                    _createVNode(_component_datei_upload_liste, { ref: "dateiuploadliste" }, null, 512)
                  ])
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
            default: _withCtx(() => [
              _cache[56] || (_cache[56] = _createTextVNode(" Zahlungs­weise  ")),
              (!_ctx.piniaStore.state.preise.produktLinien[0].einmalig)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                    onKeydown: [
                      _cache[29] || (_cache[29] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                      _cache[30] || (_cache[30] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Zahlungsweise bearbeiten"
                  }, " bearbeiten ", 32))
                : _createCommentVNode("", true)
            ]),
            _: 1,
            __: [56]
          }, 16),
          _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "zahlweise" }), {
            default: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.getZahlweiseText), 1)
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }),
      _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
            default: _withCtx(() => [
              _cache[57] || (_cache[57] = _createTextVNode(" Zahlungs­art  ")),
              _createElementVNode("a", {
                role: "button",
                tabindex: "0",
                class: "u-copy-s field-edit",
                onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                onKeydown: [
                  _cache[32] || (_cache[32] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                  _cache[33] || (_cache[33] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                ],
                "aria-label": "Zahlungsart bearbeiten"
              }, "bearbeiten", 32)
            ]),
            _: 1,
            __: [57]
          }, 16),
          _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "zahlart" }), {
            default: _withCtx(() => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.getZahlartText), 1)
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }),
      (_ctx.getBankverbindung)
        ? (_openBlock(), _createBlock(_component_zeile, {
            key: 12,
            class: "u-mar-t-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, _normalizeProps(_guardReactiveProps(_ctx.propsTitelZelle)), {
                default: _withCtx(() => [
                  _cache[58] || (_cache[58] = _createTextVNode(" IBAN  ")),
                  _createElementVNode("a", {
                    role: "button",
                    tabindex: "0",
                    class: "u-copy-s field-edit",
                    onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args))),
                    onKeydown: [
                      _cache[35] || (_cache[35] = _withKeys(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["enter"])),
                      _cache[36] || (_cache[36] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.geheZuAntragsdaten && _ctx.geheZuAntragsdaten(...args)), ["prevent"]), ["space"]))
                    ],
                    "aria-label": "Bankdaten bearbeiten"
                  }, " bearbeiten ", 32)
                ]),
                _: 1,
                __: [58]
              }, 16),
              _createVNode(_component_zelle, _mergeProps(_ctx.propsZelle, { "data-cy": "iban" }), {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getBankverbindung), 1)
                ]),
                _: 1
              }, 16)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, { class: "u-mar-t-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, _mergeProps(_ctx.propsTitelZelle, {
            "zeige-info": !_ctx.piniaStore.state.isMakler,
            "info-box-id": "beitragshilfe",
            class: "summary-label"
          }), {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true ? "" : "Ihr ") + "Bei­trag inkl. Steuer ", 1)
            ]),
            _: 1
          }, 16, ["zeige-info"]),
          (!_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state))
            ? (_openBlock(), _createBlock(_component_zelle, _mergeProps({ key: 0 }, _ctx.propsZelle, {
                class: "summary-price",
                "data-cy": "beitrag"
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.piniaStore.state.preise.produktLinien[0].einmalig
            ? _ctx.formatCurrency(_ctx.piniaStore.state.preise.produktLinien[0].einmalig)
            : _ctx.formatCurrency(
                _ctx.piniaStore.state.preise.produktLinien[_ctx.piniaStore.state.preise.produktLinienIndex].gemZahlungsweise,
              )) + " ", 1),
                  _createVNode(_component_Infotext, {
                    role: "tooltip",
                    id: "beitragshilfe",
                    name: "beitragshilfe",
                    text: "Versicherungsbeitrag inklusive Versicherungsteuer."
                  })
                ]),
                _: 1
              }, 16))
            : (_openBlock(), _createBlock(_component_zelle, _mergeProps({ key: 1 }, _ctx.propsZelle, {
                class: "summary-price",
                "data-cy": "beitrag"
              }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.formatCurrency(_ctx.gesamtPreisFH)) + " ", 1),
                  _createVNode(_component_Infotext, {
                    role: "tooltip",
                    id: "beitragshilfe",
                    name: "beitragshilfe",
                    text: "Versicherungsbeitrag inklusive Versicherungsteuer."
                  })
                ]),
                _: 1
              }, 16))
        ]),
        _: 1
      }),
      _createVNode(_component_abschluss_hinweise, {
        produkt: _ctx.props.produkt,
        zusaetzlicheSbLw: _ctx.props.zusaetzlicheSbLw
      }, null, 8, ["produkt", "zusaetzlicheSbLw"]),
      _createVNode(_component_abschluss_ihre_daten, {
        produkt: _ctx.props.produkt,
        onGeheZuAntragsdaten: _ctx.geheZuAntragsdaten
      }, null, 8, ["produkt", "onGeheZuAntragsdaten"]),
      _createVNode(_component_ueberschrift, {
        class: "u-mar-t-2",
        breite: 12,
        titel: 
        (_ctx.piniaStore.state.isMakler ? '' : 'Ihre ') + _ctx.getAntragOderVertrag(true) + 'sunterlagen und Schlusserklärung'
      ,
        "ausrichtung-responsiv": false,
        "vertikal-zentrieren": false
      }, null, 8, ["titel"]),
      _createVNode(_component_abschluss_makler, {
        onAntragAbsenden: _cache[37] || (_cache[37] = ($event: any) => (_ctx.antragAbsenden())),
        produkt: _ctx.produkt,
        fehler: _ctx.fehler,
        zeigeAngabenBestaetigen: _ctx.zeigeAngabenBestaetigen
      }, {
        "gewerbe-zulaessig": _withCtx(() => [
          _renderSlot(_ctx.$slots, "gewerbe-zulaessig")
        ]),
        "angaben-bestaetigen": _withCtx(() => [
          _renderSlot(_ctx.$slots, "angaben-bestaetigen")
        ]),
        schlusserklaerungMakler2: _withCtx(() => [
          _renderSlot(_ctx.$slots, "schlusserklaerungMakler2")
        ]),
        "button-3": _withCtx(() => [
          _renderSlot(_ctx.$slots, "button-3")
        ]),
        _: 3
      }, 8, ["produkt", "fehler", "zeigeAngabenBestaetigen"]),
      _createVNode(_component_abschluss_direkt, {
        onAntragAbsenden: _cache[38] || (_cache[38] = ($event: any) => (_ctx.antragAbsenden())),
        onVorschlagHerunterladen: _cache[39] || (_cache[39] = ($event: any) => (_ctx.vorschlagHerunterladen())),
        fehler: _ctx.fehler,
        produkt: _ctx.produkt
      }, {
        "angaben-bestaetigen": _withCtx(() => [
          _renderSlot(_ctx.$slots, "angaben-bestaetigen")
        ]),
        _: 3
      }, 8, ["fehler", "produkt"]),
      (!_ctx.sindVorherigeStepsValide())
        ? (_openBlock(), _createBlock(_component_validierungs_fehler, {
            key: 13,
            "fehler-text": _ctx.fehler.vorherigeSteps
          }, null, 8, ["fehler-text"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.istSichtbar('abschlussfehler'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          id: "abschlussfehler",
          hatSchliessenButton: true,
          titel: "Fehler beim Abschluss.",
          schliessenButtonText: "Ok",
          text: "Ihr Antrag konnte leider nicht eingereicht werden. Bitte versuchen Sie es erneut.",
          onCloseModal: _cache[40] || (_cache[40] = ($event: any) => (_ctx.wechsleSichtbarkeit('abschlussfehler'))),
          onKeydown: _cache[41] || (_cache[41] = _withKeys(($event: any) => (_ctx.wechsleSichtbarkeit('abschlussfehler')), ["esc"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.istSichtbar('modal-ferienhausDownload'))
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 1,
          titel: _ctx.getAntragOderVertrag(true) + ' herunterladen',
          text: "Download-Links:",
          onCloseModal: _cache[42] || (_cache[42] = ($event: any) => (_ctx.wechsleSichtbarkeit('modal-ferienhausDownload'))),
          onKeydown: _cache[43] || (_cache[43] = _withKeys(($event: any) => (_ctx.wechsleSichtbarkeit('modal-ferienhausDownload')), ["esc"]))
        }, {
          inhalt: _withCtx((inhaltProps) => [
            _createVNode(_component_buendel_dokument_links, {
              antrag: true,
              trackingZusatz: _ctx.trackingZusatz,
              onTextVerbergen: inhaltProps.textVerbergenToggle
            }, null, 8, ["trackingZusatz", "onTextVerbergen"])
          ]),
          _: 1
        }, 8, ["titel"]))
      : _createCommentVNode("", true)
  ], 64))
}